var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "guide-wrap" }, [
    _c("div", { staticClass: "m-wrap" }, [
      _c("div", { staticClass: "m-top" }, [
        _c("div", { staticClass: "m-h1" }, [
          _vm._v(_vm._s(_vm.$t("Bet guide"))),
        ]),
        _c("div", { staticClass: "m-h2" }, [
          _vm._v(_vm._s(_vm.$t("Placing bet"))),
        ]),
        _c("div", { staticClass: "m-steps" }, [
          _c("div", { staticClass: "m-step" }, [
            _c("img", {
              staticClass: "m-step__icon",
              attrs: { src: _vm.step1Src, alt: "" },
            }),
            _c("div", { staticClass: "m-step__text" }, [
              _vm._v(_vm._s(_vm.$t("Select bet chip"))),
            ]),
          ]),
          _c("div", { staticClass: "m-step" }, [
            _c("img", {
              staticClass: "m-step__icon",
              attrs: { src: _vm.step2Src, alt: "" },
            }),
            _c("div", { staticClass: "m-step__text" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("Place chip by clicking on preferred bet selection")
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "m-step" }, [
            _c("img", {
              staticClass: "m-step__icon",
              attrs: { src: _vm.step3Src, alt: "" },
            }),
            _c("div", { staticClass: "m-step__text" }, [
              _vm._v(_vm._s(_vm.$t("Click Bet button to confirm your bet"))),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "m-betui-wrap" }, [
          _c("img", {
            staticClass: "m-betui",
            attrs: { src: _vm.betUiSrc, alt: "" },
          }),
        ]),
      ]),
      _c("div", { staticClass: "m-bottom" }, [
        _c("div", { staticClass: "m-h1 m-h1--bottom" }, [
          _vm._v(_vm._s(_vm.$t("Fair game rules"))),
        ]),
        _c("div", { staticClass: "m-rules" }, [
          _c("div", { staticClass: "m-rule" }, [
            _c("img", {
              staticClass: "m-rule__icon",
              attrs: { src: _vm.fgr1Src, alt: "" },
            }),
            _c("div", { staticClass: "m-rule__title" }, [
              _vm._v(_vm._s(_vm.$t("Live streaming"))),
            ]),
            _c("div", { staticClass: "m-rule__desc" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began."
                    )
                  ) +
                  " "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "If the fight is not displayed on the game site, all bets will be refunded."
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "m-rule" }, [
            _c("img", {
              staticClass: "m-rule__icon",
              attrs: { src: _vm.fgr2Src, alt: "" },
            }),
            _c("div", { staticClass: "m-rule__title" }, [
              _vm._v(_vm._s(_vm.$t("Arena management decision"))),
            ]),
            _c("div", { staticClass: "m-rule__desc" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis."
                    )
                  ) +
                  " "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events."
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "m-rule" }, [
            _c("img", {
              staticClass: "m-rule__icon",
              attrs: { src: _vm.fgr3Src, alt: "" },
            }),
            _c("div", { staticClass: "m-rule__title" }, [
              _vm._v(_vm._s(_vm.$t("Bet not closed in time"))),
            ]),
            _c("div", { staticClass: "m-rule__desc" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues."
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c(
          "button",
          {
            staticClass: "m-tnc",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.toggleTNC()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("Terms & Conditions")) + " ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }